import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=a541bdac"
import script from "./ProductPrice.vue?vue&type=script&lang=ts"
export * from "./ProductPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports